module.exports = __webpack_public_path__ + "img/plano-individual-pet.8d9771eb.jpeg";